<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Świetnie!'" />
        </template>

        <div class="text-center mb-3">
            <a-icon icon="Ok" width="40px" height="40px" />
        </div>
        <p
            v-text="`Płatność przebiegła pomyślnie. Operator bramki płatniczej prześle potwierdzenie
            płatności na wskazany wcześniej adres e-mail. Do prawidłowego działania funkcjonalności
            niezbędna jest integracja urządzeń. Możesz teraz zgłosić chęć integracji
            dla wybranych sklepów, klikając w przycisk “Przejdź do listy zgłoszeń”.`"
            class="text-primary text-center font-weight-semi"
        />

        <template #footer>
            <the-btn
                text="Przejdź do panelu System Kaucyjny"
                class="btn-outline-custom"
                @click="goToDrs"
            />
            <the-btn
                text="Zamknij"
                class="btn-secondary"
                @click="$emit('close-modal')"
            />
        </template>
    </ui-modal>
</template>

<script>
export default {
    methods: {
        goToDrs() {
            this.$emit('close-modal')
            this.$router.push('/drs')
        }
    },
    created() {
        this.$store.$storage.removeItem('tariffConfig')
    }
}
</script>